import { useTranslation } from "react-i18next";
import classes from "./SectionDividerWithNoLine.module.css";

export default function SectionDividerWithNoLine({
  title,
  noMargin,
  spanClasses = "",
}) {
  const { t } = useTranslation("general");

  return (
    <div
      className={`${classes.sectionDivider} ${
        noMargin ? "u-margin_0" : "u-margin--top_500 u-margin--bottom_500"
      }`}
    >
      <span className={`${classes.text} ${spanClasses}`}>{t(title)}: </span>
    </div>
  );
}
